import { cn } from '@/lib/utils'
import type { EmojiEntry } from '@/lib/emojiShortcodes'

interface EmojiShortcodePopoverProps {
  matches: EmojiEntry[]
  selectedIndex: number
  onSelect: (entry: EmojiEntry) => void
  onHover: (index: number) => void
}

export function EmojiShortcodePopover({ matches, selectedIndex, onSelect, onHover }: EmojiShortcodePopoverProps) {
  if (matches.length === 0) return null

  return (
    <div
      className="absolute bottom-full left-0 mb-2 w-72 bg-card border border-border rounded-lg shadow-xl overflow-hidden z-20"
      role="listbox"
    >
      <div className="px-3 py-2 text-xs text-muted-foreground border-b border-border flex justify-between">
        <span>Emoji</span>
        <span className="font-mono">↑↓ Tab</span>
      </div>
      <div className="max-h-56 overflow-y-auto py-1">
        {matches.map((entry, i) => (
          <button
            key={`${entry.shortcode}-${entry.emoji}`}
            type="button"
            role="option"
            aria-selected={i === selectedIndex}
            className={cn(
              'w-full px-3 py-1.5 flex items-center gap-3 text-left cursor-pointer',
              i === selectedIndex ? 'bg-primary/15' : 'hover:bg-muted'
            )}
            onMouseEnter={() => onHover(i)}
            onMouseDown={(e) => { e.preventDefault(); onSelect(entry) }}
          >
            <span className="text-xl leading-none">{entry.emoji}</span>
            <span className="flex-1 text-sm">{entry.name}</span>
            <span className="text-xs text-muted-foreground font-mono">:{entry.shortcode}:</span>
          </button>
        ))}
      </div>
    </div>
  )
}
